import { MatTableDataSourceExtended } from "@comunicare/comunicare-angular-interfaces";
import { Appointment } from "@comunicare/comunicare-interfaces";
import * as moment from "moment";

export class TeleconsultationsListDataSource extends MatTableDataSourceExtended<Appointment> {
  sortingDataAccessor = (data: Appointment, sortHeaderId: string): string | number => {
    switch (sortHeaderId) {
      case "startDate":
        return moment(data.start).unix();
      case "endDate":
        return moment(data.end).unix();
      case "object":
        return data.description.toLowerCase();
      default:
        return "";
    }
  };

  constructor() {
    super();
  }

  public loadData(visios: Appointment[]): void {
    this.data = visios;
  }
}
